import { NavLink } from "@remix-run/react";
import { NavIconProps } from "~/utils/interfaces/components";

const WorkIcon = (props: NavIconProps) => {
  const {
    width = 24,
    height = 24,
    color = "#BCBCBC",
    color2 = "#3fff6f",
    label = "",
    selected = false,
    name = "home",
  } = props;

  return (
    <NavLink
      to={name}
      aria-label="Work"
      className={({ isActive, isPending }) => {
        return `nav-item-container ${
          isActive ? "active" : isPending ? "pending" : ""
        }`;
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${24} ${24}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M20 9V11.92L19.22 11.47C18.58 11.1 17.78 11.21 17.26 11.71C17.15 11.81 17.06 11.93 16.98 12.06L16.92 12.17C16.81 12.36 16.72 12.41 16.71 12.42C16.69 12.41 16.59 12.36 16.48 12.16L16.42 12.06C16.2 11.68 15.85 11.42 15.43 11.31C15 11.19 14.56 11.25 14.19 11.47L13.28 12C12.87 12.23 12.58 12.61 12.46 13.06C12.34 13.52 12.4 13.99 12.63 14.4C12.74 14.58 12.74 14.69 12.74 14.71C12.73 14.72 12.63 14.78 12.41 14.78C11.44 14.78 10.65 15.57 10.65 16.53V17.47C10.65 18.43 11.44 19.22 12.41 19.22C12.63 19.22 12.73 19.28 12.73 19.29C12.74 19.3 12.74 19.42 12.63 19.6C12.56 19.73 12.5 19.86 12.47 20H9C6.24 20 4 17.76 4 15V9C4 6.24 6.24 4 9 4H15C17.76 4 20 6.24 20 9Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M17.2602 9.74023V11.7102C17.1502 11.8102 17.0602 11.9302 16.9802 12.0602L16.9202 12.1702C16.8102 12.3602 16.7202 12.4102 16.7102 12.4202C16.6902 12.4102 16.5902 12.3602 16.4802 12.1602L16.4202 12.0602C16.2002 11.6802 15.8502 11.4202 15.4302 11.3102C15.0002 11.1902 14.5602 11.2502 14.1902 11.4702L13.2802 12.0002C12.8702 12.2302 12.5802 12.6102 12.4602 13.0602C12.3402 13.5202 12.4002 13.9902 12.6302 14.4002C12.7402 14.5802 12.7402 14.6902 12.7402 14.7102C12.7302 14.7202 12.6302 14.7802 12.4102 14.7802C11.4402 14.7802 10.6502 15.5702 10.6502 16.5302V17.2602H9.74023C8.09023 17.2602 6.74023 15.9102 6.74023 14.2602V9.74023C6.74023 8.09023 8.09023 6.74023 9.74023 6.74023H14.2602C15.9102 6.74023 17.2602 8.09023 17.2602 9.74023Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M9.06006 2.75V4H9.00006C8.50006 4 8.02006 4.07 7.56006 4.21V2.75C7.56006 2.34 7.89006 2 8.31006 2C8.72006 2 9.06006 2.34 9.06006 2.75Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M12.75 2.75V4H11.25V2.75C11.25 2.34 11.59 2 12 2C12.41 2 12.75 2.34 12.75 2.75Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M16.4502 2.75V4.21C15.9902 4.07 15.5002 4 15.0002 4H14.9502V2.75C14.9502 2.34 15.2902 2 15.7002 2C16.1102 2 16.4502 2.34 16.4502 2.75Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M22 8.2998C22 8.7198 21.67 9.0498 21.25 9.0498H20V8.9998C20 8.4998 19.93 8.0098 19.79 7.5498H21.25C21.67 7.5498 22 7.8898 22 8.2998Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M9.06006 20V21.25C9.06006 21.66 8.72006 22 8.31006 22C7.89006 22 7.56006 21.66 7.56006 21.25V19.79C8.02006 19.93 8.50006 20 9.00006 20H9.06006Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M4.21 7.5498C4.07 8.0098 4 8.4998 4 8.9998V9.0498H2.75C2.34 9.0498 2 8.7198 2 8.2998C2 7.8898 2.34 7.5498 2.75 7.5498H4.21V7.5498Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M4 11.25V12.75H2.75C2.34 12.75 2 12.41 2 12C2 11.58 2.34 11.25 2.75 11.25H4Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M4.21 16.4502H2.75C2.34 16.4502 2 16.1102 2 15.7002C2 15.2802 2.34 14.9502 2.75 14.9502H4V15.0002C4 15.5002 4.07 15.9902 4.21 16.4502Z"
          fill={color}
          className="svg-path"
        />
        <path
          opacity="0.4"
          d="M20.9899 15.53C20.3099 15.53 19.9199 15.19 19.9199 14.69C19.9199 14.49 19.9799 14.26 20.1199 14.02C20.3999 13.54 20.2299 12.92 19.7499 12.65L18.8399 12.12C18.4199 11.87 17.8799 12.02 17.6299 12.44L17.5699 12.54C17.0899 13.37 16.3099 13.37 15.8299 12.54L15.7699 12.44C15.5299 12.02 14.9799 11.87 14.5699 12.12L13.6499 12.65C13.3299 12.83 13.1399 13.17 13.1399 13.52C13.1399 13.69 13.1899 13.86 13.2799 14.02C13.4199 14.26 13.4899 14.49 13.4899 14.69C13.4899 15.19 13.0899 15.53 12.4099 15.53C11.8599 15.53 11.3999 15.98 11.3999 16.53V17.47C11.3999 18.02 11.8599 18.47 12.4099 18.47C13.0899 18.47 13.4899 18.81 13.4899 19.31C13.4899 19.51 13.4199 19.74 13.2799 19.98C12.9999 20.46 13.1699 21.08 13.6499 21.35L14.5699 21.88C14.9799 22.13 15.5299 21.98 15.7699 21.56L15.8299 21.46C16.3099 20.63 17.0899 20.63 17.5699 21.46L17.6299 21.56C17.8799 21.98 18.4199 22.13 18.8399 21.88L19.7499 21.35C20.0699 21.17 20.2599 20.83 20.2599 20.48C20.2599 20.31 20.2099 20.14 20.1199 19.98C19.9799 19.74 19.9199 19.51 19.9199 19.31C19.9199 18.81 20.3099 18.47 20.9899 18.47C21.5499 18.47 21.9999 18.02 21.9999 17.47V16.53C21.9999 15.98 21.5499 15.53 20.9899 15.53ZM16.6999 18.72C15.7499 18.72 14.9799 17.95 14.9799 17C14.9799 16.05 15.7499 15.28 16.6999 15.28C17.6499 15.28 18.4199 16.05 18.4199 17C18.4199 17.95 17.6499 18.72 16.6999 18.72Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M18.42 16.9998C18.42 17.9498 17.65 18.7198 16.7 18.7198C15.75 18.7198 14.98 17.9498 14.98 16.9998C14.98 16.0498 15.75 15.2798 16.7 15.2798C17.65 15.2798 18.42 16.0498 18.42 16.9998Z"
          fill={color}
          className="svg-path"
        />
      </svg>
      <p className="nav-label">{label}</p>
    </NavLink>
  );
};

export default WorkIcon;
